// @ vendor
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');

// @ commons
const { formatText } = require('core/i18n').i18n;
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');

// @ utilities
const { isDisasterRecoveryMode } = require('utilities/contactCenter/disasterRecoveryhelper');

class SendN2PasswordErrorStep extends React.Component {
    handleEndInteraction() {
        this.props.history.push('/disasterRecovery/customerFinder');
    }

    render() {
        const title = formatText('wizardError-errorTitle');
        const errorSubTitle = formatText('wizardError-errorSubTitle');
        const textLink = formatText('addImposition-disasterRecoveryConfirmationBackbtn');

        return (
            <article className="row no-gutter">
                <CustomMessageBox
                    icon="icon-warning"
                    title={title}
                    subtitle={errorSubTitle}
                    textLink={isDisasterRecoveryMode() ? textLink : '  '}
                    goBackHandler={isDisasterRecoveryMode() ? () => this.handleEndInteraction() : '&nspb'}
                />
            </article>
        )
    }
}

SendN2PasswordErrorStep.propTypes = {
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(SendN2PasswordErrorStep);
